// Hardcoded fallback Program Outcomes (POs) — used automatically when the
// database has no program outcome entries yet.

export const PROGRAM_OUTCOMES_FALLBACK = [
  {
    id: 'po1',
    code: 'PO 1',
    title: 'Engineering Knowledge',
    description: 'Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.',
  },
  {
    id: 'po2',
    code: 'PO 2',
    title: 'Problem Analysis',
    description: 'Identify, formulate, review research literature, and analyze complex engineering problems using first principles of mathematics, natural sciences, and engineering sciences to arrive at substantiated conclusions.',
  },
  {
    id: 'po3',
    code: 'PO 3',
    title: 'Design/Development of Solutions',
    description: 'Design solutions for complex engineering problems and design system components or processes that meet specified needs with appropriate consideration for public health and safety, cultural, societal, and environmental considerations.',
  },
  {
    id: 'po4',
    code: 'PO 4',
    title: 'Conduct Investigations of Complex Problems',
    description: 'Use research-based knowledge and research methods including design of experiments, analysis and interpretation of data, and synthesis of information to provide valid conclusions.',
  },
  {
    id: 'po5',
    code: 'PO 5',
    title: 'Modern Tool Usage',
    description: 'Create, select, and apply appropriate techniques, resources, and modern engineering and IT tools, including prediction and modeling, with an understanding of their limitations.',
  },
  {
    id: 'po6',
    code: 'PO 6',
    title: 'The Engineer and Society',
    description: 'Apply reasoning informed by contextual knowledge to assess societal, health, safety, legal, and cultural issues and the consequent responsibilities relevant to professional engineering practice.',
  },
  {
    id: 'po7',
    code: 'PO 7',
    title: 'Environment and Sustainability',
    description: 'Understand the impact of professional engineering solutions in societal and environmental contexts and demonstrate knowledge of sustainable development.',
  },
  {
    id: 'po8',
    code: 'PO 8',
    title: 'Ethics',
    description: 'Apply ethical principles and commit to professional ethics, responsibilities, and norms of engineering practice.',
  },
  {
    id: 'po9',
    code: 'PO 9',
    title: 'Individual and Team Work',
    description: 'Function effectively as an individual and as a member or leader in diverse teams and multidisciplinary settings.',
  },
  {
    id: 'po10',
    code: 'PO 10',
    title: 'Communication',
    description: 'Communicate effectively on complex engineering activities with the engineering community and society at large through reports, design documentation, presentations, and clear instructions.',
  },
  {
    id: 'po11',
    code: 'PO 11',
    title: 'Project Management and Finance',
    description: 'Demonstrate knowledge and understanding of engineering and management principles and apply these to manage projects in multidisciplinary environments.',
  },
  {
    id: 'po12',
    code: 'PO 12',
    title: 'Life-long Learning',
    description: 'Recognize the need for, and engage in, independent and life-long learning in the broadest context of technological change.',
  },
];
